import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Icon = ({name, className, lg, ...props}) => {
  const classes = classNames('bl', 'bl-' + name, className, {'fa-lg': lg});

  return <i className={classes} {...props} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  lg: PropTypes.bool,
  className: PropTypes.string,
};

export default Icon;
